import type { ResumeData } from '../../lib/types';

export default function Summary({ data }: { data: ResumeData }) {
  return (
    <section className="container-fluid">
      {data.summary && (
        <div className="summary">
          <div className="row">
            <div className="col-sm-12">{data.summary}</div>
          </div>
        </div>
      )}
      {data.summary_points && data.summary_points.length > 0 && (
        <div className="summary-points">
          <ul>
            {data.summary_points.map((point, i) => (
              <li key={i}>{point}</li>
            ))}
          </ul>
        </div>
      )}
    </section>
  );
}
